import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { MessageBox, Message } from 'element-ui'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
  headers: {
    post: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    put: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    get: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    delete: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  },
  responseType: 'json'
})

// request interceptor
service.interceptors.request.use(config => {
  // do something before request is sent
  if (store.getters.token) config.headers['X-Access-Token'] = getToken()

  return config
}, error => {
  // do something with request error
  console.error(error) // for debug
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use(({ data }) => {
  if (data.code === 200) {
    return data.data
  } else if (data.code === 1004 || data.code === 1005) {
    MessageBox.confirm('您的登录信息已过期，请重新登录', '温馨提示', {
      confirmButtonText: '重新登录',
      showCancelButton: false,
      type: 'warning'
    }).then(() => {
      store.dispatch('user/resetToken').then(() => {
        location.reload()
      })
    })
    return Promise.reject(data.message)
  } else {
    Message.error(data.message)
    console.error('接口错误', data.message)
    return Promise.reject(data.message)
  }
}, error => {
  Message.error(error.message)
  console.error('Error', error)
  return Promise.reject(error.message)
})

export default service
